import { useMutation } from "@tanstack/react-query";
import { trainerAccountApi } from "api/trainers/trainerAccountApi";

export const useGenerateTrainerAccount = (trainerId: number) => {
  return useMutation({
    mutationFn: () => trainerAccountApi.generateAccount(trainerId),
  });
};
